import { useTranslation } from 'react-i18next';
import { formatDateRange } from './model/formatDateRange';
import type { IRelatedTask } from './model/listItem';

export interface IRelatedTaskRowProps {
  task: IRelatedTask;
  language: string;
  year: number;
  /** Per-surface class names (the drawer panel and the hover tooltip style rows differently). */
  classes: { row?: string; name?: string; meta?: string };
}

/**
 * One predecessor/successor row — task name plus its date range and progress.
 * Shared by the card's DependencyTooltip and the drawer's Dependencies section so
 * the row's shape and formatting live in a single place. An uncommitted
 * neighbour is still listed (it is the plan's), and says so.
 */
export function RelatedTaskRow({ task, language, year, classes }: IRelatedTaskRowProps) {
  const { t } = useTranslation();
  return (
    <div className={classes.row}>
      <span className={classes.name}>{task.name}</span>
      <span className={classes.meta}>
        {formatDateRange(task.start, task.end, language, year)} · {task.progressPercent}%
        {!task.committed && ` · ${t('activities.deps.uncommitted')}`}
      </span>
    </div>
  );
}
